// extracted by mini-css-extract-plugin
export default {"invite":"invite_invite__erIUd"};